function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import PaginationVue from '@/components/PaginationVue';
import SandboxViewsTabComponent from '@/apps/attributes/modules/use_cases/components/SandboxViewsTabComponent';
import { useCaseMixin } from '@/apps/attributes/mixins/use_case_mixin';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { envConfig } from '@/js/constants';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { filterMixin } from '@/mixins/filter_mixin';
import { localPaginationMixin } from '@/mixins/local_pagination';
import LogAwsExportComponent from '@/apps/attributes/modules/use_cases/components/LogAwsExportComponent.vue';
import ExportBaseTabComponent from '@/apps/attributes/modules/use_cases/components/ExportBaseTabComponent.vue';
export default {
  name: 'UseCaseDetailComponent',
  components: {
    LogAwsExportComponent: LogAwsExportComponent,
    ExportBaseTabComponent: ExportBaseTabComponent,
    SandboxViewsTabComponent: SandboxViewsTabComponent,
    PaginationVue: PaginationVue
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [useCaseMixin, filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return {
      tab: null,
      search: '',
      useCaseLogs: [],
      pagination: {
        attributes: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        logs: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        }
      },
      TYPE_VIEWS: {
        BIGQUERY: 'bigquery',
        INTERNAL: 'internal'
      },
      isAdmin: false,
      keyTable2: 0,
      logItems: [],
      log_headers: [{
        text: 'Usuario',
        value: 'creation_user'
      }, {
        text: 'Descripción',
        value: 'description'
      }, {
        text: 'Estado',
        value: 'status_id'
      }, {
        text: 'Creación',
        value: 'creation_date'
      }],
      baseExportItems: [],
      base_export_headers: [{
        text: 'Tabla origen',
        value: 'source_table'
      }, {
        text: 'Tabla destino',
        value: 'dest_table'
      }, {
        text: 'Usuario',
        value: 'creation_user'
      }, {
        text: 'Motivo',
        value: 'reason'
      }, {
        text: 'Tipo de exportación',
        value: 'export_type'
      }, {
        text: 'Estado',
        value: 'status_id'
      }, {
        text: 'Fecha de solicitud',
        value: 'creation_date'
      }, {
        text: 'Fecha de expiración',
        value: 'expiration_date'
      }]
    };
  },
  created: function created() {
    var _this = this;
    this.getUseCase(this.item.company_code).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getUseCaseLogs();
            _this.getBusinessAreas();
            if (_this.useCase.company_code === '000') {
              _this.getAwsExports();
            }
            if (_this.useCase.source === 'ATHENA' && _this.useCase.company_code === '000') {
              _this.getBaseExports();
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
  },
  methods: {
    refreshSandboxTab: function refreshSandboxTab() {
      console.log('Base eliminada');
      this.$emit('update');
    },
    getUseCaseLogs: function getUseCaseLogs() {
      var _this2 = this;
      this.isAdmin = false;
      if (this.userHasRole(this.rolesINCA.ATTRIBUTE_ADMIN)) {
        this.isAdmin = true;
      }
      var params = {};
      if (this.isAdmin) {
        params = {
          full: '1'
        };
      }
      UseCasesService.getLogs(this.item.company_code, this.item.id, params).then(function (response) {
        console.log(response);
        _this2.useCaseLogs = response.data.records;
      });
    },
    getUseCaseAndViews: function getUseCaseAndViews() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.TYPE_VIEWS.BIGQUERY;
      var useCase = {};
      var internalViews = [];
      var externalViews = [];
      switch (type) {
        case this.TYPE_VIEWS.BIGQUERY:
          useCase.id = this.useCase.id;
          useCase.project_sand = this.useCase.project_sand;
          useCase.dataset_sand = this.useCase.dataset_sand;
          internalViews = this.useCase.view_group_int;
          externalViews = this.useCase.view_group_ext;
          break;
        case this.TYPE_VIEWS.INTERNAL:
          if (Object.values(this.useCase.view_group_int_company).length) {
            var firstViewInt = Object.values(this.useCase.view_group_int_company)[0];
            var view = firstViewInt.split('.');
            useCase.project_sand = view[0];
            useCase.dataset_sand = view[1];
            internalViews = this.useCase.view_group_int_company;
            externalViews = this.useCase.view_group_ext_company;
          }
          break;
      }
      console.log('this.useCase.attributes: ', this.useCase.attributes);
      var baseAttributes = this.useCase.attributes.map(function (item) {
        return {
          attribute_name: item.attribute_name,
          attribute_object_name: item.attribute_object_name,
          attribute_scheme_name: item.attribute_scheme_name,
          attribute_project_name: item.attribute_project_name,
          attribute_description: item.attribute_description || 'Atributo de tabla creada en Sandbox',
          is_partyid: item.is_partyid,
          is_external: item.is_external,
          attribute_source_id: 1,
          attribute_filters: {},
          attribute_category: item.attribute_category,
          attribute_dtype: item.attribute_dtype,
          attribute_notnull: -1,
          company_code_usr: item.company_code_usr,
          attribute_view_name: item.attribute_view_name,
          company_code: item.company_code
        };
      });
      var params = {
        company_code: this.companyCode,
        company_name: this.useCase.company_name,
        append: true,
        flag_data_ext: '1',
        applicant: this.userEmail,
        rdetail: baseAttributes,
        call_approval_method: false,
        company_code_usr: this.companyCode
      };
      useCase.params = params;
      useCase.views = [].concat(_toConsumableArray(Object.values(internalViews).map(function (view) {
        return {
          name: view,
          type: 'internal'
        };
      })), _toConsumableArray(Object.values(externalViews).map(function (view) {
        return {
          name: view,
          type: 'external'
        };
      })));
      console.log('use case views: ', useCase);
      console.log('this.use case views: ', this.useCase);
      console.log(useCase);
      return useCase;
    },
    getAwsExports: function getAwsExports() {
      var _this3 = this;
      UseCasesService.ListIbkExportSandboxToAws(this.item.id).then(function (response) {
        _this3.logItems = response.data.records;
      });
    },
    getBaseExports: function getBaseExports() {
      var _this4 = this;
      UseCasesService.ListBaseExports(this.item.id).then(function (response) {
        _this4.baseExportItems = response.data.records;
      });
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['statusLogTypes'])), {}, {
    headersAttributesTab: function headersAttributesTab() {
      return [{
        text: this.translate('table_attributes_use_case_detail.attribute'),
        value: 'attribute_name'
      }, {
        text: this.translate('table_attributes_use_case_detail.description'),
        value: 'attribute_description'
      }, {
        text: this.translate('table_attributes_use_case_detail.source'),
        value: 'attribute_source_id'
      }, {
        text: 'Vista',
        value: 'attribute_object_name'
      }];
    },
    headersLogsTab: function headersLogsTab() {
      return [{
        text: this.translate('table_use_case_logs.description'),
        value: 'description'
      }, {
        text: this.translate('table_use_case_logs.log_type'),
        value: 'status_logtype_id'
      }, {
        text: this.translate('table_use_case_logs.applicant'),
        value: 'applicant'
      }, {
        text: this.translate('table_use_case_logs.response'),
        value: 'response'
      }, {
        text: this.translate('table_use_case_logs.created'),
        value: 'creation_date'
      }];
    },
    getLogType: function getLogType() {
      var _this5 = this;
      return function (logTypeId) {
        return _this5.statusLogTypes.status_logtype_id[logTypeId.toString()].toUpperCase();
      };
    },
    getDateAndHours: function getDateAndHours() {
      return function (raw) {
        // "2025-07-14T08:32:37.000" o solo fecha "2026-12-11" (sin hora)
        var _split = (raw || '').split('T'),
          _split2 = _slicedToArray(_split, 2),
          d = _split2[0],
          hms = _split2[1];
        return {
          date: d ? d.split('-').reverse().join('-') : '',
          // DD-MM-YYYY
          hour: hms ? hms.slice(0, 8) : '' // HH:mm:ss (vacío si no hay hora)
        };
      };
    },
    useCaseApproved: function useCaseApproved() {
      return this.useCase.status_id && this.useCase.status_id === 3;
    }
  })
};